import React from 'react'
import PropTypes from 'prop-types'
import { ReportsTable } from '../../organism'
import { MODULES } from '../../../config/constants'

const Reports = ({ classes }) => (
  <div className={classes.root}>
    <ReportsTable module={MODULES.ID_FEEDBACK} />
  </div>
)

Reports.propTypes = {
  i18n: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
}

export default Reports
